// Sample content shown inside the app screen mockups.
export const appEvents = [
  {
    id: 'home-fair',
    title: 'Home & Living Fair',
    city: 'Utrecht',
    date: 'Sat 14 Mar',
    category: 'Consumer fair',
    action: 'Quiz',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5b50be48-200c-4de5-9577-2de420000ee5.jpg',
  },
  {
    id: 'summer-fest',
    title: 'Summer Festival',
    city: 'Amsterdam',
    date: 'Sat 20 Jun',
    category: 'Festival',
    action: 'Photo mission',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/516ef107-4d6b-4e20-b94e-27c564b09b2f.jpg',
  },
  {
    id: 'food-market',
    title: 'Night Food Market',
    city: 'Rotterdam',
    date: 'Fri 3 Jul',
    category: 'Food',
    action: 'Check-in',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b72d6da3-946c-4373-8d55-9e3e5f6a05fa.jpg',
  },
];
